import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom'
import ListPublicaciones from './Components/ListPublicaciones';
import PublicacionNew from './Components/ABM/PublicacionNew'; 
import PublicacionEdit from './Components/ABM/PublicacionEdit'
import CreacionMasivaPublicaciones from './Components/Excel/CreacionMasivaPublicaciones';
import CreacionMasivaWizard from './Components/Excel/CreacionMasivaWizard';
import ActualizacionMasivaPublicaciones from './Components/Excel/ActualizacionMasivaPublicaciones';
import { isProductionRuntime } from '../../utilities/runtimeEnvironment';

export default class AdmPublicaciones extends React.Component {
    render () {
        const showGuidedWizard = !isProductionRuntime();

        return (
            <div>
                <Routes>
                    <Route path="" element={<ListPublicaciones/>}/>
                    <Route path="Nueva/:idSeller" element={<PublicacionNew/>}/>
                    <Route path="Editar/:idSeller/:id" element={<PublicacionEdit/>}/>
                    <Route path="CreacionMasiva" element={<CreacionMasivaPublicaciones/>}/>
                    <Route
                        path="CreacionMasivaWizard"
                        element={showGuidedWizard ? <CreacionMasivaWizard/> : <Navigate to="/Publicaciones/CreacionMasiva" replace />}
                    />
                    <Route path="ActualizacionMasiva" element={<ActualizacionMasivaPublicaciones/>} />
                </Routes>
            </div>
        ); 
    }
}
